import {
  getTwoColumnWidgetLayoutGuardResult,
  TwoColumnWidgetLayoutLimits,
} from './getTwoColumnWidgetLayoutGuardResult.ts';

export const assertTwoColumnWidgetLayoutConfigInDev = (
  limits: TwoColumnWidgetLayoutLimits,
  columnRange: { min: number; max: number }
): void => {
  if (!import.meta.env.DEV) {
    return;
  }

  for (
    let numberOfColumnsInWidget = columnRange.min;
    numberOfColumnsInWidget <= columnRange.max;
    numberOfColumnsInWidget += 1
  ) {
    const guard = getTwoColumnWidgetLayoutGuardResult({
      ...limits,
      numberOfColumnsInWidget,
    });

    if (!guard.ok) {
      console.error('[TwoColumnWidgetLayout] invalid layout config', {
        ...limits,
        columnRange,
        numberOfColumnsInWidget,
        guard,
      });
    }
  }
};
